class TeamDelegate {
    setSearchQuery(searchQuery) {
        this.setState({ searchQuery });
    }

    setShowAddMemberModal(showAddMemberModal) {
        this.setState({ showAddMemberModal });
    }

    setNewMemberEmail(newMemberEmail) {
        this.setState({ newMemberEmail });
    }

    setNewMemberRole(newMemberRole) {
        this.setState({ newMemberRole });
    }
}

export default TeamDelegate;

